//------------------------------------ doc
// import Original_PSD_files from '../../../assets/Doc/Original PSD files [FR].rar'
import LowRes from '../../../assets/Doc/LowRes.pdf'
import LowRes_AR from '../../../assets/Doc/LowRes_AR.pdf'
import millensys_profile_en from '../../../assets/Doc/millensys_profile_en.pdf'
import millensys_profile_ar from '../../../assets/Doc/millensys_profile_ar.pdf'
import miclinic_ehr_LowRes from '../../../assets/Doc/miclinic_ehr_LowRes.pdf'
// import miclinic_ehr_Original_PSD_Files from '../../../assets/Doc/miclinic_ehr_Original_PSD_Files.rar'
import miclinic_LowRes from '../../../assets/Doc/miclinic_LowRes.pdf'
// import miclinic_emr_Original_PSD_Files from '../../../assets/Doc/miclinic_emr_Original_PSD_Files.rar'
import workspace_vna__LowRes from '../../../assets/Doc/workspace_vna__LowRes.pdf'
// import workspace_vna_Original_PSD_Files from '../../../assets/Doc/workspace_vna_Original_PSD_Files.rar'
import workspace_pacs_LowRes from '../../../assets/Doc/workspace_pacs_LowRes.pdf'
// import workspace_pacs_Original_PSD_Files from '../../../assets/Doc/workspace_pacs_Original_PSD_Files.rar'
import miris_LowRes from '../../../assets/Doc/miris_LowRes.pdf'
// import miris_Original_PSD_Files from '../../../assets/Doc/miris_Original_PSD_Files.rar'
import mipublisher_LowRes from '../../../assets/Doc/mipublisher_LowRes.pdf'
import mipublisher_h_HiRes from '../../../assets/Doc/mipublisher_h_HiRes.pdf'
// import mipublisher_Original_PSD_Files from '../../../assets/Doc/mipublisher_Original_PSD_Files.rar'

import multiview_LowRes from '../../../assets/Doc/multiview_LowRes.pdf'
import multiview_Original_PSD_Files from '../../../assets/Doc/multiview_Original_PSD_Files.rar'
import _3dview_Vision_Tools_3Dview from '../../../assets/Doc/3dview_Vision_Tools_3Dview.pdf'
import ctview_Vision_Tools_CTview from '../../../assets/Doc/ctview_Vision_Tools_CTview.pdf'
import mrview_Vision_Tools_MRview from '../../../assets/Doc/mrview_Vision_Tools_MRview.pdf'
import mammoview_Vision_Tools_MammoView from '../../../assets/Doc/mammoview_Vision_Tools_MammoView.pdf'
// import mammoview__Original_PSD_Files from '../../../assets/Doc/mammoview__Original_PSD_Files.rar'
import operapro_Vision_Tools_OperaPro from '../../../assets/Doc/operapro_Vision_Tools_OperaPro.pdf'

import multiview_LowRes_2 from '../../../assets/Doc/multiview_LowRes_2.pdf'
import cathview_Vision_Tools_CathView from '../../../assets/Doc/cathview_Vision_Tools_CathView.pdf'
import sonopro_Vision_Tools_SonoPro from '../../../assets/Doc/sonopro_Vision_Tools_SonoPro.pdf'
import endo_Vision_Tools_Endo from '../../../assets/Doc/endo_Vision_Tools_Endo.pdf'
// import endo__Original_PSD_Files from '../../../assets/Doc/endo__Original_PSD_Files.rar'
import telerad_Tele_Radiology_Solution from '../../../assets/Doc/telerad_Tele_Radiology_Solution.pdf'
//-------------------------------------------
import About_MILLENSYS_1 from '../../../assets/Doc/About_MILLENSYS_1.pptx'
import About_MILLENSYS_2 from '../../../assets/Doc/About_MILLENSYS_2.pdf'
import millensys_projects from '../../../assets/Doc/millensys_projects.pdf'
import millensys_2018_project_ideas from '../../../assets/Doc/millensys_2018_project_ideas.pdf'
import mihealth from '../../../assets/Doc/mihealth.pptx'
import millensys_dignostic_solution from '../../../assets/Doc/millensys_dignostic_solution.pptx'
import miclinic_ehr from '../../../assets/Doc/miclinic_ehr.pptx'
import workspace_vna from '../../../assets/Doc/workspace_vna.pptx'
import miclinic_lis from '../../../assets/Doc/miclinic_lis.pptx'

import millensys_telehealth from '../../../assets/Doc/millensys_telehealth.pptx'
import millensys_homecare from '../../../assets/Doc/millensys_homecare.pptx'
import healthwallet from '../../../assets/Doc/healthwallet.pptx'
import millensys_telerad from '../../../assets/Doc/millensys_telerad.pptx'

import workspace from '../../../assets/Doc/workspace.pptx'
import miclinic_ris from '../../../assets/Doc/miclinic_ris.pptx'
import miris from '../../../assets/Doc/miris.pptx'
import mireport from '../../../assets/Doc/mireport.pptx'
import pacs_ris_components from '../../../assets/Doc/pacs_ris_components.pptx'
import pacs_ris_workflow from '../../../assets/Doc/pacs_ris_workflow.swf'

import multiview12_8 from '../../../assets/Doc/multiview12_8.pptx'
import _3dview from '../../../assets/Doc/_3dview.pptx'
import cathview from '../../../assets/Doc/cathview.pptx'
import radview from '../../../assets/Doc/radview.pptx'
import sonopro from '../../../assets/Doc/sonopro.pptx'
import mixlink from '../../../assets/Doc/mixlink.pptx'

import pacs_ris_workflow_2 from '../../../assets/Doc/pacs_ris_workflow (1).swf'

import miclinic_user_manual from '../../../assets/Doc/miclinic_user_manual.pdf'
import workspace_vna_user_manual from '../../../assets/Doc/workspace_vna_user_manual.pdf'
import workspace_user_manual from '../../../assets/Doc/workspace_user_manual.pdf'
import vtools_user_manual from '../../../assets/Doc/vtools_user_manual.pdf'

import mierp_user_manual_ar from '../../../assets/Doc/mierp_user_manual_ar.pdf'
import mierp_user_manual_en from '../../../assets/Doc/mierp_user_manual_en.pdf'
import mierp_user_manual_fr from '../../../assets/Doc/mierp_user_manual_fr.pdf'
import mierp_hr_user_manual from '../../../assets/Doc/mierp_hr_user_manual.pdf'

import vtools_quick_manual from '../../../assets/Doc/vtools_quick_manual.pdf'
import vt3dview_quick_manual from '../../../assets/Doc/vt3dview_quick_manual.pdf'
import webview_quick_manual from '../../../assets/Doc/webview_quick_manual.pdf'
import mipublisher_quick_manual from '../../../assets/Doc/mipublisher_quick_manual.pdf'
import miprint_quick_manual from '../../../assets/Doc/miprint_quick_manual.pdf'
import miviewer_quick_manual from '../../../assets/Doc/miviewer_quick_manual.pdf'
import miadmin_quick_manual from '../../../assets/Doc/miadmin_quick_manual.pdf'
import workspace_url_integration_guide from '../../../assets/Doc/workspace_url_integration_guide.pdf'

import mammorep_quickguide from '../../../assets/Doc/mammorep_quickguide.pdf'
import cathreport_quickguide from '../../../assets/Doc/cathreport_quickguide.pdf'
// import vtools12_6 from '../../../assets/Doc/vtools12_6.wmv';

// import vrt1 from '../../../assets/Doc/vrt1.wmv';
import vrt2 from '../../../assets/Doc/vrt2.wmv';
// import vessel_analysis from '../../../assets/Doc/vessel_analysis.wmv';
import virtual_colonoscopy from '../../../assets/Doc/virtual_colonoscopy.wmv';
// import coronary_analysis from '../../../assets/Doc/coronary_analysis.wmv';
import calcium_scoring from '../../../assets/Doc/calcium_scoring.wmv';
// import petct_fusion from '../../../assets/Doc/petct_fusion.wmv';

// import MiRIS_Part1 from '../../../assets/Doc/MiRIS-Part1.wmv';
// import MiRIS_Part2 from '../../../assets/Doc/MiRIS-Part2.wmv';

import millensys_miclinic_tech_specs from '../../../assets/Doc/millensys_miclinic_tech_specs.pdf';
import millensys_miclinic_ehr_tech_specs from '../../../assets/Doc/millensys_miclinic_ehr_tech_specs.pdf';
import millensys_miclinic_emr_tech_specs from '../../../assets/Doc/millensys_miclinic_emr_tech_specs.pdf';
import millensys_workspace_vna_tech_specs from '../../../assets/Doc/millensys_workspace_vna_tech_specs.pdf';


import millensys_workspace_tech_specs from '../../../assets/Doc/millensys_workspace_tech_specs.pdf';
import multiview_basic_mpr_tech_specs from '../../../assets/Doc/multiview_basic_mpr_tech_specs.pdf';
import multiview_tech_specs from '../../../assets/Doc/multiview_tech_specs.pdf';
import millensys_mipacs_tech_specs from '../../../assets/Doc/millensys_mipacs_tech_specs.pdf';
import vision_tool_workspace_features_map from '../../../assets/Doc/vision_tool_workspace_features_map.pdf';
import millensys_software_technical_specifications from '../../../assets/Doc/millensys_software_technical_specifications.pdf';

import millensys_miclinic_ris_tech_specs  from '../../../assets/Doc/millensys_miclinic_ris_tech_specs.pdf';
import millensys_miris_tech_specs from '../../../assets/Doc/millensys_miris_tech_specs.pdf';
import millensys_ris_features_map from '../../../assets/Doc/millensys_ris_features_map.pdf';
import millensys_miclinic_lis_tech_specs from '../../../assets/Doc/millensys_miclinic_lis_tech_specs.pdf';
import millensys_telerad_tech_specs from '../../../assets/Doc/millensys_telerad_tech_specs.pdf';

import mipublisher_tech_specs from '../../../assets/Doc/mipublisher_tech_specs.pdf';
import miprint_tech_specs from '../../../assets/Doc/miprint_tech_specs.pdf';

import mibroker_specification from '../../../assets/Doc/mibroker_specification.pdf';
import mibroker_technical_paper from '../../../assets/Doc/mibroker_technical_paper.pdf';


import mammoview_tech_specs from '../../../assets/Doc/mammoview_tech_specs.pdf'
import radview_tech_specs from '../../../assets/Doc/radview_tech_specs.pdf'
import operapro_specs from '../../../assets/Doc/operapro_specs.pdf'
import cathview_specs from '../../../assets/Doc/cathview_specs.pdf'
import millensys_advantage_points from '../../../assets/Doc/millensys_advantage_points.pdf'

import tender_specs_PACS_RIS_general_english from '../../../assets/Doc/tender_specs_PACS_RIS_general english.docx'
import tender_specs_PACS_RIS_general from '../../../assets/Doc/tender_specs_PACS_RIS_general.docx'
import tender_specs_PACS_RIS_detailed from '../../../assets/Doc/tender_specs_PACS_RIS_detailed.docx'
import tender_specs_miris from '../../../assets/Doc/tender_specs_miris.docx'
import tender_specs_PACS_EHR_general from '../../../assets/Doc/tender_specs_PACS_EHR_general.docx'
import tender_specs_EMR_general from '../../../assets/Doc/tender_specs_EMR_general.docx'
import tender_specs_EHR_general from '../../../assets/Doc/tender_specs_EHR_general.docx'
import tender_specs_EHR_ERP_general from '../../../assets/Doc/tender_specs_EHR_ERP_general.docx'

import millensys_ihe2011_connectathon from '../../../assets/Doc/millensys_ihe2011_connectathon.pdf'
import miclinic_ihe from '../../../assets/Doc/miclinic_ihe.pdf'
import workspace_vna_ihe from '../../../assets/Doc/workspace_vna_ihe.pdf'
import workspace_ihe from '../../../assets/Doc/workspace_ihe.pdf'
import mipacs_2_ihe from '../../../assets/Doc/mipacs_2_ihe.pdf'
import miris_ihe from '../../../assets/Doc/miris_ihe.pdf'
import mibroker_ihe from '../../../assets/Doc/mibroker_ihe.pdf'
import mibroker_hl7 from '../../../assets/Doc/mibroker_hl7.pdf'
import workspace_dicom from '../../../assets/Doc/workspace_dicom.pdf'
import mipacs_2_dicom from '../../../assets/Doc/mipacs_2_dicom.pdf'
import mibroker_dicom from '../../../assets/Doc/mibroker_dicom.pdf'
import multiview_dicom from '../../../assets/Doc/multiview_dicom.pdf'
import ctview_dicom from '../../../assets/Doc/ctview_dicom.pdf'
import mrview_dicom from '../../../assets/Doc/mrview_dicom.pdf'
import sonopro_dicom from '../../../assets/Doc/sonopro_dicom.pdf'
import radview_dicom from '../../../assets/Doc/radview_dicom.pdf'
import operapro_dicom from '../../../assets/Doc/operapro_dicom.pdf'
import cathview_dicom from '../../../assets/Doc/cathview_dicom.pdf'
import endo_dicom from '../../../assets/Doc/endo_dicom.pdf'

import ctview_connection from '../../../assets/Doc/ctview_connection.pdf'
import mrview_connection from '../../../assets/Doc/mrview_connection.pdf'
import operapro_connection from '../../../assets/Doc/operapro_connection.pdf'
import radview_connection from '../../../assets/Doc/radview_connection.pdf'
import cathview_connection from '../../../assets/Doc/cathview_connection.pdf'
import gview_connection from '../../../assets/Doc/gview_connection.pdf'
import sonopro_connection from '../../../assets/Doc/sonopro_connection.pdf'
import endo_connection from '../../../assets/Doc/endo_connection.pdf'

import Global_PACS_2016_FINAL from '../../../assets/Doc/Global_PACS_2016_FINAL.pdf'
import millensys_iso13485_certificate from '../../../assets/Doc/millensys_iso13485_certificate.pdf'
import millensys_iso9001_certificate from '../../../assets/Doc/millensys_iso9001_certificate.pdf'
import millensys_ce_certificate from '../../../assets/Doc/millensys_ce_certificate.pdf'
import millensys_fda_510k_approval from '../../../assets/Doc/millensys_fda_510k_approval.pdf'
import millensys_ihe2011_connectathon_2 from '../../../assets/Doc/millensys_ihe2011_connectathon_2.pdf'

import his_questionnaire from '../../../assets/Doc/his_questionnaire.docx'
import ehr_questionnaire from '../../../assets/Doc/ehr_questionnaire.docx'
import erp_questionnaire from '../../../assets/Doc/erp_questionnaire.docx'
import pacsfdbk from '../../../assets/Doc/pacsfdbk.docx'
import teleradfdbk from '../../../assets/Doc/teleradfdbk.docx'
import lis_questionnaire from '../../../assets/Doc/lis_questionnaire.docx'







export const docsData = [
    {
        title : 'MILLENSYS Health care Brochure' ,
        arr : [
            {link : LowRes ,linkName : 'LowRes'},
            // {link : Original_PSD_files,linkName : 'Original PSD files [FR]'},
        ]
    },
    {
        title : 'MILLENSYS Business Brochure' ,
        arr : [
            {link : LowRes_AR ,linkName : 'LowRes_AR'},
        ]
    },
    {
        title : 'MILLENSYS Profile' ,
        arr : [
            {link : millensys_profile_en ,linkName : 'MILLENSYS Profile En'},
            {link : millensys_profile_ar ,linkName : 'MILLENSYS Profile Ar'},
        ]
    },
    {
        title : 'MILLENSYS MiClinic EHR' ,
        arr : [
            {link : miclinic_ehr_LowRes ,linkName : 'LowRes'},
            // {link : miclinic_ehr_Original_PSD_Files ,linkName : 'Original PSD Files'},
        ]
    },
    {
        title : 'MILLENSYS MiClinic EMR' ,
        arr : [
            {link : miclinic_LowRes ,linkName : 'LowRes'},
            // {link : miclinic_emr_Original_PSD_Files,linkName : 'Original PSD Files'},
        ]
    },
    {
        title : 'Vision Tools Workspace VNA' ,
        arr : [
            {link : workspace_vna__LowRes ,linkName : 'LowRes'},
            // {link : workspace_vna_Original_PSD_Files ,linkName : 'Original PSD Files'},
        ]
    },
    {
        title : 'Vision Tools Workspace PACS' ,
        arr : [
            {link : workspace_pacs_LowRes ,linkName : 'LowRes'},
            // {link : workspace_pacs_Original_PSD_Files,linkName : 'Original PSD Files'},
        ]
    }
]
export const docsData_2 = [
    {
        title : 'MILLENSYS RIS' ,
        arr : [
            {link : miris_LowRes ,linkName : 'LowRes'},
            // {link : miris_Original_PSD_Files,linkName : 'Original PSD Files'},
        ]
    },
    {
        title : 'MILLENSYS CD/DVD publisher' ,
        arr : [
            {link : mipublisher_LowRes ,linkName : 'LowRes'},
            {link : mipublisher_h_HiRes,linkName : 'HiRes'},
            // {link : mipublisher_Original_PSD_Files,linkName : 'Original PSD Files'},
        ]
    },
    {
        title : 'Vision Tools MultiView' ,
        arr : [
            {link : multiview_LowRes ,linkName : 'LowRes'},
            {link : multiview_Original_PSD_Files,linkName : 'Original PSD Files'},
            {link : _3dview_Vision_Tools_3Dview,linkName : '3dview Vision Tools 3Dview'},
            {link : ctview_Vision_Tools_CTview,linkName : 'Vision Tools CTview'},
            {link : mrview_Vision_Tools_MRview,linkName : 'Vision Tools MRview'},
            {link : mammoview_Vision_Tools_MammoView,linkName : 'Vision Tools MammoView'},
            // {link : mammoview__Original_PSD_Files,linkName : 'Original PSD Files'},
            {link : operapro_Vision_Tools_OperaPro,linkName : 'Vision Tools OperaPro'},
        ]
    },
    {
        title : 'Vision Tools MultiView Cardiac' ,
        arr : [
            {link : multiview_LowRes_2 ,linkName : 'LowRes'},
            {link : cathview_Vision_Tools_CathView,linkName : 'Vision Tools CathView'},
            {link : sonopro_Vision_Tools_SonoPro,linkName : 'Vision Tools SonoPro'},
            {link : endo_Vision_Tools_Endo,linkName : 'Vision Tools Endo'},
            // {link : endo__Original_PSD_Files,linkName : 'Original PSD file'},
            {link : telerad_Tele_Radiology_Solution,linkName : 'Tele-Radiology Solution'},
        ]
    },
]
export const docsData_3 = [
    {
        title : 'MILLENSYS, The Company' ,
        arr : [
            {link : About_MILLENSYS_1 ,linkName : 'About MILLENSYS'},
            {link : About_MILLENSYS_2,linkName : 'About MILLENSYS'},
        ]
    },
    {
        title : 'Projects' ,
        arr : [
            {link : millensys_projects ,linkName : 'MILLENSYS Main Awarded Projects'},
            {link : millensys_2018_project_ideas ,linkName : 'MILLENSYS Project Ideas'},
        ]
    },
    {
        title : 'Unified Solutions' ,
        arr : [
            {link : mihealth ,linkName : 'MILLENSYS E-Health Solution'},
            {link : millensys_dignostic_solution ,linkName : 'MILLENSYS Diagnostic Solution (Radiology / Lab)'},
        ]
    },
    {
        title : 'Healthcare Solutions' ,
        arr : [
            {link : miclinic_ehr ,linkName : 'MILLENSYS EHR "MiClinic - EHR"'},
        ]
    },
    {
        title : 'Enterprise Imaging Solutions' ,
        arr : [
            {link : workspace_vna ,linkName : 'Vision Tools Workspace VNA'},
        ]
    },
    {
        title : 'Laboratory Solutions' ,
        arr : [
            {link : miclinic_lis ,linkName : 'MILLENSYS LIS "MiClinic - Lab'},
        ]
    }
]
export const docsData_4 = [
    {
        title : 'Tele Solutions' ,
        arr : [
            {link : millensys_telehealth ,linkName : 'MILLENSYS Tele-Health Solutions.'},
            {link : millensys_homecare,linkName : 'MILLENSYS Home Care Platform.'},
            {link : healthwallet,linkName : 'MILLENSYS Health Wallet Mobile App.'},
            {link : millensys_telerad,linkName : 'Teleradiology'},
        ]
    },
    {
        title : 'Radiology Solutions' ,
        arr : [
            {link : workspace ,linkName : 'Vision Tools Workspace PACS.'},
            {link : miclinic_ris,linkName : 'MILLENSYS RIS "MiClinic - Radiology"'},
            {link : miris,linkName : 'MILLENSYS RIS "MiRIS"'},
            {link : mireport,linkName : 'MILLENSYS Reporting'},
            {link : pacs_ris_components,linkName : 'PACS/RIS Components'},
            {link : pacs_ris_workflow,linkName : 'PACS/RIS Workflow'},
        ]
    },
    {
        title : 'Workstations and Viewers' ,
        arr : [
            {link : multiview12_8 ,linkName : 'Vision Tools MultiView'},
            {link : _3dview,linkName : 'Vision Tools 3Dview'},
            {link : cathview,linkName : 'Vision Tools CathView'},
            {link : radview,linkName : 'Vision Tools RadView'},
            {link : sonopro,linkName : 'Vision Tools SonoPro'},
            {link : mixlink,linkName : 'MiXlink Gateway'},
        ]
    },
    {
        title : 'Multimedia Demo' ,
        arr : [
            {link : pacs_ris_workflow_2 ,linkName : 'RIS , PACS Workflow (~3MB)'},
        ]
    },
]


export const docsData_5 = [
    {
        title : 'User Manuals (EN)' ,
        arr : [
            {link : miclinic_user_manual ,linkName : 'MiClinic EMR / EHR'},
            {link : workspace_vna_user_manual,linkName : 'Vision Tools Workspace VNA'},
            {link : workspace_user_manual,linkName : 'Vision Tools Workspace PACS'},
            {link : vtools_user_manual,linkName : 'Vision Tools Workstations'},
        ]
    },
    {
        title : 'ERP Financial Management User Manuals' ,
        arr : [
            {link : mierp_user_manual_ar ,linkName : 'MiERP financial management (AR)'},
            {link : mierp_user_manual_en,linkName : 'MiERP financial management (EN)'},
            {link : mierp_user_manual_fr,linkName : 'MiERP financial management (FR)'},
            {link : mierp_hr_user_manual,linkName : 'MiERP-HR - Human Resources Management (AR)'}
        ]
    },
    {
        title : 'Quick Manuals' ,
        arr : [
            {link : vtools_quick_manual ,linkName : 'Vision Tools MultiView'},
            {link : vt3dview_quick_manual,linkName : 'Vision Tools 3DView'},
            {link : webview_quick_manual,linkName : 'Vision Tools WebView (WebPACS)'},
            {link : mipublisher_quick_manual,linkName : 'MiPublisher'},
            {link : miprint_quick_manual,linkName : 'MiPrint'},
            {link : miviewer_quick_manual,linkName : 'MiViewer 6.8 (DICOM Viewer)'},
            {link : miadmin_quick_manual,linkName : 'Millensys Web Administrator (MiAdmin)'},
            {link : workspace_url_integration_guide,linkName : 'Workspace URL integration Guide'},
        ]
    }
]

export const docsData_6 = [
    {
        title : 'Workspace VNA Training Videos' ,
        arr : [
            {link : 'https://www.youtube.com/watch?v=i_dHyEtVAUU&feature=youtu.be' ,linkName : 'Session # 1 : Workspace VNA Introduction'},
        ]
    },
    {
        title : 'MiClinic Training Videos' ,
        arr : [
            {link : 'https://www.youtube.com/watch?v=NF4UeCYKRvI&feature=youtu.be' ,linkName : 'MiClinic , Call Center Module , training session'},
            {link : 'https://www.youtube.com/watch?v=cyt4iahfMXU&feature=youtu.be' ,linkName : 'MiClinic , Scheduling / admittance training session 1'},
            {link : 'https://www.youtube.com/watch?v=AV6M6j8I82g&feature=youtu.be' ,linkName : 'MiClinic , Scheduling / admittance training session 2'},
            {link : 'https://www.youtube.com/watch?v=LQha9TolimA&feature=youtu.be' ,linkName : 'MiClinic , Doctor Workflow training session'},
            {link : 'https://www.youtube.com/watch?v=GS-dep2400M&feature=youtu.be' ,linkName : 'MiClinic ,Notification Module training session'},
            {link : 'https://www.youtube.com/watch?v=vW7Ac-7JC8c' ,linkName : 'MiClinic v.s. MiRIS'},
        ]
    },
    {
        title : 'Software Quick Guides' ,
        arr : [
            {link : mammorep_quickguide ,linkName : 'Mammography (SR) Reporting Module'},
            {link : cathreport_quickguide,linkName : 'Cathlab (SR) Reporting Module'},
        ]
    },
]
export const docsData_7 = [
    {
        title : 'Workspace 6.0 Training Videos' ,
        arr : [
            {link : 'https://www.youtube.com/watch?v=UUT_OUN4V7w&feature=youtu.be' ,linkName : 'Session # 1 : work list management'},
            {link : 'https://www.youtube.com/watch?v=GqEzCZ9TCwY&feature=youtu.be' ,linkName : 'Session # 2 : vieweing and reporting'},
            {link : 'https://www.youtube.com/watch?v=PQUg6Xut5G4&feature=youtu.be' ,linkName : 'Session # 3 : advanced viewer # 1'},
        ]
    },
    // {
    //     title : 'Vision Tools Demo' ,
    //     arr : [
    //         {link : vtools12_6 ,linkName : 'Vision Tools 12.6 Getting Started Demo'},
    //     ]
    // },
    {
        title : '3DView Demo' ,
        arr : [
            // {link : vrt1 ,linkName : 'Volume Render Demo#1'},
            {link : vrt2 ,linkName : 'Volume Render Demo#2'},
            // {link : vessel_analysis ,linkName : 'Vessel Analysis'},
            {link : virtual_colonoscopy ,linkName : 'Virtual Colonography'},
            // {link : coronary_analysis ,linkName : 'Cardiac (Coronary)'},
            {link : calcium_scoring ,linkName : 'Calcium Scoring'},
            // {link : petct_fusion ,linkName : 'PET/CT Fusion'},
        ]
    },
    // {
    //     title : 'MiRIS Training Videos' ,
    //     arr : [
    //         {link : MiRIS_Part1 ,linkName : 'MiRIS 5.0 Demo Part #1'},
    //         {link : MiRIS_Part2 ,linkName : 'MiRIS 5.0 Demo Part #2'},
    //     ]
    // },
]


export const docsData_8 = [
    {
        title : 'MiERP Training Videos' ,
        arr : [
            {link : 'https://www.youtube.com/watch?v=pWRiiqDkRtA&feature=youtu.be' ,linkName : 'ERP Workflow Training Session 1'},
            {link : 'https://www.youtube.com/watch?v=3uVjcHEJ1po' ,linkName : 'ERP Workflow Training Session 2'},
            {link : 'https://www.youtube.com/watch?v=EgmG7F9Pbho&feature=youtu.be' ,linkName : 'ERP Workflow Training Session 3'},
            {link : 'https://www.youtube.com/watch?v=VT429rp91Og&feature=youtu.be' ,linkName : 'ERP Workflow Training Session 4'},
            {link : 'https://www.youtube.com/watch?v=mkjSOIeyaLs&feature=youtu.be' ,linkName : 'ERP Workflow Training Session 5'},
            {link : 'https://www.youtube.com/watch?v=59LidFFejfk' ,linkName : 'Human Resources Management , Training Session 1'},
            {link : 'https://www.youtube.com/watch?v=GObafkRp5FM&feature=youtu.be' ,linkName : 'MILLENSYS Analytics | MiAnalytics , Training Session 1'},
        ]
    },
    {
        title : 'MiAnalytics Training Videos' ,
        arr : [
            {link : 'https://www.youtube.com/watch?v=GObafkRp5FM&feature=youtu.be' ,linkName : 'MiAnalytics , Training Session 1'},
        ]
    },
]
export const docsData_9 = [
    {
        title : 'EHR / EMR / ERP' ,
        arr : [
            {link : millensys_miclinic_tech_specs ,linkName : 'MiClinic (EHR/ERP) full package Technical Specifications'},
            {link :  millensys_miclinic_ehr_tech_specs ,linkName : 'MiClinic (EHR) electronic health record Technical Specifications'},
            {link : millensys_miclinic_emr_tech_specs ,linkName : 'MiClinic (EMR) electronic medical record Technical Specifications'},
        ]
    },
    {
        title : 'VNA' ,
        arr : [
            {link : millensys_workspace_vna_tech_specs ,linkName : 'VNA (Vendor Neutral Archive) Technical Specifications'},
        ]
    },
    {
        title : 'PACS' ,
        arr : [
            {link : millensys_workspace_tech_specs ,linkName : 'Vision Tools Workspace (PACS/Reporting) Technical Specifications'},
            {link : multiview_basic_mpr_tech_specs ,linkName : 'Vision Tools MultiView Basic Technical Specifications'},
            {link : multiview_tech_specs,linkName : 'Vision Tools MultiView Advanced Technical Specifications'},
            {link : millensys_mipacs_tech_specs ,linkName : 'MiPACS (PACS Archive Server) Technical Specifications'},
            {link : vision_tool_workspace_features_map ,linkName : 'Vision Tools Workspace Features Map'},
            {link : millensys_software_technical_specifications ,linkName : 'PACS/RIS General Technical Specifications'},
        ]
    },
]




export const docsData_10 = [
    {
        title : 'PACS / RIS' ,
        arr : [
            {link : tender_specs_PACS_RIS_general_english ,linkName : 'PACS / RIS Tender specs . (General ) - (EN)'},
            {link : tender_specs_PACS_RIS_general ,linkName : 'PACS / RIS Tender specs (General ) - (AR)'},
            {link : tender_specs_PACS_RIS_detailed ,linkName : 'PACS / RIS Tender specs (Detailed )'},
            {link :  tender_specs_miris,linkName : 'RIS Tender specs (Detailed )'},
        ]
    },
    {
        title : 'PACS / EHR' ,
        arr : [
            {link :  tender_specs_PACS_EHR_general,linkName : 'PACS / EHR Tender specs (General)'},
        ]
    },
    {
        title : 'EHR / EMR / ERP' ,
        arr : [
            {link : tender_specs_EMR_general ,linkName : 'EMR Tender specs'},
            {link :  tender_specs_EHR_general,linkName : 'EHR Tender specs'},
            {link : tender_specs_EHR_ERP_general ,linkName : 'EHR / ERP Tender specs'},
        ]
    },
    {
        title : 'Other Documents' ,
        arr : [
            {link : millensys_advantage_points ,linkName : 'MILLENSYS Advanced Features'},
        ]
    },
]

export const docsData_11 = [
    {
        title : 'IHE Integration Statements' ,
        arr : [
            {link : millensys_ihe2011_connectathon ,linkName : 'IHE Connectathon Results'},
            {link : miclinic_ihe ,linkName : 'MiClinic'},
            {link : workspace_vna_ihe ,linkName : 'Vision Tools Workspace VNA'},
            {link : workspace_ihe ,linkName : 'Vision Tools Workspace PACS'},
            {link : mipacs_2_ihe ,linkName : 'MiPACS'},
            {link : miris_ihe,linkName : 'MiRIS'},
            {link : mibroker_ihe ,linkName : 'MiBroker'},
        ]
    },
    {
        title : 'HL7 Conformance Statements' ,
        arr : [
            {link : mibroker_hl7 ,linkName : 'MiBroker HL7 Integration Document'},
        ]
    },
]

export const docsData_12 = [
    {
        title : 'Acquisition WS Connectivity' ,
        arr : [
            {link : ctview_connection ,linkName : 'Vision Tools CTview'},
            {link : mrview_connection ,linkName : 'Vision Tools CTview'},
            {link : operapro_connection ,linkName : 'Vision Tools OperaPro'},
            {link : radview_connection ,linkName : 'Vision Tools RadView'},
            {link : cathview_connection ,linkName : 'Vision Tools CathView'},
            {link : gview_connection ,linkName : 'Vision Tools GView'},
            {link : sonopro_connection ,linkName : 'Vision Tools SonoPro'},
            {link : endo_connection ,linkName : 'Vision Tools Endo'},
        ]
    },
]
export const docsData_13 = [
    {
        title : 'Quality Certificates' ,
        arr : [
            {link : Global_PACS_2016_FINAL ,linkName : 'Best in KLAS 2016/2017'},
            {link : millensys_iso13485_certificate ,linkName : 'ISO 13485'},
            {link : millensys_iso9001_certificate ,linkName : 'ISO 9001'},
            {link : millensys_ce_certificate ,linkName : 'CE Certificate'},
            {link : millensys_fda_510k_approval ,linkName : 'FDA (510K) Approval'},
            {link : millensys_ihe2011_connectathon_2 ,linkName : 'IHE Connectathon'},
        ]
    },
    {
        title : 'RIS' ,
        arr : [
            {link : millensys_miclinic_ris_tech_specs ,linkName : 'MiClinic Radiology (RIS) Technical Specifications'},
            {link : millensys_miris_tech_specs ,linkName : 'MiRIS (RIS) Technical Specifications'},
            {link : millensys_ris_features_map ,linkName : 'MILLENSYS RIS Features Map'},
        ]
    },
    {
        title : 'LIS' ,
        arr : [
            {link : millensys_miclinic_lis_tech_specs ,linkName : 'MILLENSYS Laboratory (LIS) Technical Specifications'},
        ]
    },
    {
        title : 'Teleradiology' ,
        arr : [
            {link : millensys_telerad_tech_specs ,linkName : 'MILLENSYS Teleradiology Solution Technical Specifications'},
        ]
    },
]
export const docsData_14 = [
    {
        title : 'ntegration' ,
        arr : [
            {link :  mibroker_specification,linkName : 'MiBroker Technical Specs'},
            {link :  mibroker_technical_paper,linkName : 'MiBroker Technical Paper'},
        ]
    },
    {
        title : 'Workstations and Acquisition' ,
        arr : [
            {link : mammoview_tech_specs ,linkName : 'Vision Tools MammoView Technical Specifications'},
            {link : radview_tech_specs ,linkName : 'Vision Tools RadView Technical Specifications'},
            {link : operapro_specs ,linkName : 'Vision Tools OperaPro Technical Specifications'},
            {link : cathview_specs ,linkName : 'Vision Tools CathView Technical Specifications'},
        ]
    },
    {
        title : 'Production Tools' ,
        arr : [
            {link : mipublisher_tech_specs ,linkName : 'MiPublisher (Medical Disc Publisher) Technical Specifications'},
            {link : miprint_tech_specs ,linkName : 'MiPrint (DICOM to Paper Print) Technical Specifications'},
        ]
    },
]
export const docsData_15 = [
    {
        title : 'DICOM Conformance Statements' ,
        arr : [
            {link : workspace_dicom ,linkName : 'Vision Tools Workspace PACS Server'},
            {link : mipacs_2_dicom,linkName : 'MiPACS Server'},
            {link : mibroker_dicom ,linkName : 'MiBroker Worklist Server'},
            {link : multiview_dicom ,linkName : 'Vision Tools MultiView'},
            {link : ctview_dicom ,linkName : 'Vision Tools CTview'},
            {link : mrview_dicom,linkName : 'Vision Tools MRview'},
            {link : sonopro_dicom ,linkName : 'Vision Tools SonoPro'},
            {link : radview_dicom,linkName : 'Vision Tools RadView'},
            {link : operapro_dicom ,linkName : 'Vision Tools OperaPro'},
            {link : cathview_dicom ,linkName : 'Vision Tools CathView'},
            {link : endo_dicom ,linkName : 'Vision Tools Endo'},
        ]
    },
]
export const docsData_16 = [
    {
        title : 'Questionaire' ,
        arr : [
            {link : his_questionnaire ,linkName : 'HIS Request for Information'},
            {link : ehr_questionnaire ,linkName : 'EMR / EHR Requset for Information'},
            {link : erp_questionnaire,linkName : 'ERP Request for Information'},
            {link : pacsfdbk ,linkName : 'PACS/RIS Request for Information'},
            {link : teleradfdbk ,linkName : 'Teleradiology Request for Information'},
            {link : lis_questionnaire ,linkName : 'LIS Request for Information'},
        ]
    },
]